import StyledModal from '@/components/StyledModal/StyledModal.tsx';
import CustomSpinner from '@/components/Spinner.tsx';
import useRetrieveAutomationLlmUsage from '@/hooks/api/llmUsage/useRetrieveAutomationLlmUsage.ts';
import { Automation } from '@/types/automations.ts';
import MetadataJsonViewer from '@/components/MetadataJsonViewer.tsx';

type Props = {
  automation: Automation;
  opened: boolean;
  onClose: () => void;
};

const AutomationMetadataModal = ({ automation, opened, onClose }: Props) => {
  const { data: llmUsage, isLoading } = useRetrieveAutomationLlmUsage(automation.id, opened);

  return (
    <StyledModal
      opened={opened}
      onClose={onClose}
      title={`Automation Metadata - ${automation.id}`}
      centered
      size="xl"
      withCloseButton={true}
    >
      {isLoading ? (
        <CustomSpinner size="md" />
      ) : (
        <MetadataJsonViewer
          src={{
            automation,
            llm_usage: llmUsage || null,
          }}
        />
      )}
    </StyledModal>
  );
};

export default AutomationMetadataModal;
